module.exports = __webpack_public_path__ + "img/8.3d7174e0.jpeg";